<template lang="pug">
  router-link.d-block.anniversary-home-header.position-relative.txt-white(to="/30-jahre-jubilaeum")
    .p-4
      .row
        .col-12.text-center.col-lg-3.order-1.d-flex.align-items-center.order-lg-0
          .text-center.w-100
            .pre-title.font-weight-semibold Wir feiern
            img.img-fluid.w-100(src="https://s3-cloud.td-cdn.de/Images/Promo/30-Jahre-TD/dreissig.png" style="max-width:85px;")
            .h1.m-0.title Jahre touriDat
        .col-12.col-lg-7.order-2.order-lg-1
          .box.p-3.mb-3 Jeden Monat verlosen wir eine wunderbare Reise aus unserem großen touriDat-Portfolio!
          .box.p-3 Zusätzlich zwischen drei erlesenen Angeboten wählen und 30€ extra Rabatt mit dem jeweiligen Code erhalten!
        .col-12.order-0.col-lg-2.order-lg-2.d-flex.align-items-center.justify-content-center.text-center
          .cta.aspect-square.rounded-circle.p-2.d-inline-flex.align-items-center.justify-content-center.small
            | zur Anmeldung
            font-awesome-icon.ml-1(icon="chevron-right")

</template>
<script>
export default {
  name: "AnniversaryHomeHeader"
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/anniversary-colors";
@import "@/assets/styles/mediaqueries";

.anniversary-home-header {
  text-decoration: none;
  transition: box-shadow 0.4s;
  background-color: #222;
  border-radius: 10px;
  margin-bottom: 50px;
  margin-top: 75px;

  @include md {
    background-color: rgba(34, 34, 34, 0.7);
    backdrop-filter: blur(7px);
  }

  @include lg {
    margin-top: 0;
  }

  &:hover {
    box-shadow: 0 0 15px $color-anniversary-light;
  }
}

.pre-title {
  font-size: 1rem;
}

.title, .pre-title {
  color: $color-anniversary-light;
}

.box {
  background-color: $color-anniversary-dark;
  border-left: 4px solid $color-anniversary-light;
}

.cta {
  background-color: $color-anniversary-dark;
  position: absolute;
  top: -110px;
  @include lg {
    position: relative;
    top: 0;
  }
}
</style>
